/*
 * @Author: victorjhu
 * @Date: 2023-01-03 17:27:53
 */
import { isServer } from './is-server';
;
export function getBrowserInfo() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    if (isServer) {
        return null;
    }
    var userAgentStr = ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
    var browserInfo = {};
    var browserArray = {
        IE: (window === null || window === void 0 ? void 0 : window.ActiveXObject) || 'ActiveXObject' in window,
        Chrome: userAgentStr.indexOf('chrome') > -1 && userAgentStr.indexOf('safari') > -1,
        Firefox: userAgentStr.indexOf('firefox') > -1,
        Opera: userAgentStr.indexOf('opera') > -1,
        Safari: userAgentStr.indexOf('safari') > -1 && userAgentStr.indexOf('chrome') === -1,
        Edge: userAgentStr.indexOf('edge') > -1 || userAgentStr.indexOf('edg') > -1,
        QQBrowser: userAgentStr.indexOf('qqbrowser') > -1 || userAgentStr.indexOf('qq') > -1,
        WeixinBrowser: userAgentStr.indexOf('micromessenger') > -1,
        VivoBrowser: userAgentStr.indexOf('vivobrowser') > -1,
        HuaweiBrowser: userAgentStr.indexOf('huaweibrowser') > -1,
        MiuiBrowser: userAgentStr.indexOf('miuibrowser') > -1,
        TencentWemeet: userAgentStr.indexOf('app/tencent_wemeet') > -1,
        DingTalk: userAgentStr.indexOf('dingtalk') > -1,
        Youku: userAgentStr.indexOf('youku') > -1,
        HeyTapBrowser: userAgentStr.indexOf('heytapbrowser') > -1, // HeyTapBrowser
    };
    for (var _i = 0, _u = Object.keys(browserArray); _i < _u.length; _i++) {
        var i = _u[_i];
        if (browserArray[i]) {
            var versions = void 0;
            if (i === 'IE') {
                versions = (_b = userAgentStr.match(/(msie\s|trident.*rv:)([\w.]+)/)) === null || _b === void 0 ? void 0 : _b[2];
            }
            else if (i === 'Chrome') {
                for (var _v = 0, _w = Object.keys(navigator.mimeTypes); _v < _w.length; _v++) {
                    var mt = _w[_v];
                    // 检测是否是360浏览器(测试只有pc端的360才起作用)
                    if (navigator.mimeTypes[mt].type === 'application/360softmgrplugin') {
                        i = '360';
                    }
                }
                versions = (_c = userAgentStr.match(/chrome\/([\d.]+)/)) === null || _c === void 0 ? void 0 : _c[1];
            }
            else if (i === 'Firefox') {
                versions = (_d = userAgentStr.match(/firefox\/([\d.]+)/)) === null || _d === void 0 ? void 0 : _d[1];
            }
            else if (i === 'Opera') {
                versions = (_e = userAgentStr.match(/opera\/([\d.]+)/)) === null || _e === void 0 ? void 0 : _e[1];
            }
            else if (i === 'Safari') {
                versions = (_f = userAgentStr.match(/version\/([\d.]+)/)) === null || _f === void 0 ? void 0 : _f[1];
            }
            else if (i === 'Edge') {
                versions = ((_g = userAgentStr.match(/edge\/([\d.]+)/)) === null || _g === void 0 ? void 0 : _g[1]) || ((_h = userAgentStr.match(/edg\/([\d.]+)/)) === null || _h === void 0 ? void 0 : _h[1]);
            }
            else if (i === 'QQBrowser') {
                versions = ((_j = userAgentStr.match(/qqbrowser\/([\d.]+)/)) === null || _j === void 0 ? void 0 : _j[1]) || ((_k = userAgentStr.match(/qq\/([\d.]+)/)) === null || _k === void 0 ? void 0 : _k[1]);
            }
            else if (i === 'WeixinBrowser') {
                versions = (_l = userAgentStr.match(/micromessenger\/([\d.]+)/)) === null || _l === void 0 ? void 0 : _l[1];
            }
            else if (i === 'VivoBrowser') {
                versions = (_m = userAgentStr.match(/vivobrowser\/([\d.]+)/)) === null || _m === void 0 ? void 0 : _m[1];
            }
            else if (i === 'HuaweiBrowser') {
                versions = (_o = userAgentStr.match(/huaweibrowser\/([\d.]+)/)) === null || _o === void 0 ? void 0 : _o[1];
            }
            else if (i === 'MiuiBrowser') {
                versions = (_p = userAgentStr.match(/miuibrowser\/([\d.]+)/)) === null || _p === void 0 ? void 0 : _p[1];
            }
            else if (i === 'TencentWemeet') {
                versions = (_q = userAgentStr.match(/app_version\/([\d.]+)/)) === null || _q === void 0 ? void 0 : _q[1];
            }
            else if (i === 'DingTalk') {
                versions = (_r = userAgentStr.match(/dingtalk\/([\d.]+)/)) === null || _r === void 0 ? void 0 : _r[1];
            }
            else if (i === 'Youku') {
                versions = (_s = userAgentStr.match(/youku\/([\d.]+)/)) === null || _s === void 0 ? void 0 : _s[1];
            }
            else if (i === 'HeyTapBrowser') {
                versions = (_t = userAgentStr.match(/heytapbrowser\/([\d.]+)/)) === null || _t === void 0 ? void 0 : _t[1];
            }
            browserInfo.type = i;
            browserInfo.versions = versions;
        }
    }
    return browserInfo;
}
